import request from '@/utils/request'
// 获取推广计划
export function getAdvertList(params) {
  return request({
    url: `/ad_management/campaigns`,
    method: 'get',
    params
  })
}
// 创建推广计划
export function adAdvertList(data) {
  return request({
    url: `/ad_management/campaigns`,
    method: 'post',
    data
  })
}
// 更新推广计划
export function updataAdvertList(id, updata) {
  return request({
    url: `/ad_management/campaigns?account_id=${id}`,
    method: 'put',
    updata
  })
}

// 删除推广计划
export function delAdvertList(id, campaign_id) {
  return request({
    url: `/ad_management/campaigns?account_id=${id}&campaign_id=${campaign_id}`,
    method: 'delete'
  })
}

// 获取广告组
export function getAdvertGroup(params) {
  return request({
    url: `/ad_management/adgroups`,
    method: 'get',
    params
  })
}

// 创建广告组
export function adAdvertGroup(data) {
  return request({
    url: `/ad_management/adgroups`,
    method: 'post',
    data
  })
}

// 更新推广告组
export function updataAdvertGroup(id, updataGroup) {
  return request({
    url: `/ad_management/adgroups/account_id=${id}`,
    method: 'put',
    updataGroup
  })
}

// 删除广告组
export function delAdverGroup(id, campaign_id) {
  return request({
    url: `/ad_management/adgroups/?account_id=${id}&campaign_id=${campaign_id}`,
    method: 'delete'
  })
}

// 批量操作
export function batchOperat(data = []) {
  return request({
    url: `/ad_management/batch/add`,
    method: 'post',
    data
  })
}

// 批量修改广告主日限额
export function batchSetAdvertiserQuota(data = []) {
  return request({
    url: `/ad_management/batch/advertisers/update_daily_budget`,
    method: 'post',
    data
  })
}

// 批量修改推广计划日限额
export function batchSetPlanQuota(data = []) {
  return request({
    url: `/ad_management/batch/campaigns/update_daily_budget`,
    method: 'post',
    data
  })
}

// 批量修改广告组日限额
export function batchSetGroupQuota(data = []) {
  return request({
    url: `/ad_management/batch/adgroups/update_daily_budget`,
    method: 'post',
    data
  })
}

// 批量修改推广计划开启/暂停状态
export function batchSetPlanOpenOff(data = []) {
  return request({
    url: `/ad_management/batch/campaigns/update_configured_status`,
    method: 'post',
    data
  })
}

// 批量修改广告组开启/暂停状态
export function batchSetGroupOpenOff(data = []) {
  return request({
    url: `/ad_management/batch/adgroups/update_configured_status`,
    method: 'post',
    data
  })
}

// 批量修改广告开启/暂停状态
export function batchSetAdvertOpenOff(data = []) {
  return request({
    url: `/ad_management/batch/ads/update_configured_status`,
    method: 'post',
    data
  })
}

// 批量修改广告组投放起止时间
export function batchSetGroupUpdateTime(data = []) {
  return request({
    url: `/ad_management/batch/adgroups/update_datetime`,
    method: 'post',
    data
  })
}

// 批量修改广告组出价
export function batchSetGroupBid(data = []) {
  return request({
    url: `/ad_management/batch/adgroups/update_bid_amount`,
    method: 'post',
    data
  })
}
